<div class="content">
  <nz-tabset
    [nzSize]="'small'"
    [nzSelectedIndex]="activeTabIdx"
    (nzSelectedIndexChange)="onSelectedTabIndexChange($event)"
  >
    <nz-tab nzTitle="By Date">
      <ng-container *ngTemplateOutlet="byDateContent"></ng-container>
    </nz-tab>
    <nz-tab nzTitle="By Broker">
      <ng-container *ngTemplateOutlet="byBroker"></ng-container>
    </nz-tab>
  </nz-tabset>

  <div class="footer">
    <div *ngIf="note" class="note">{{ note }}</div>
    <div class="action-btns">
      <button
        class="btn-secondary"
        nz-button
        nzType="link"
        (click)="handleCancel()"
      >
        Cancel
      </button>
      <!-- below ccCompare pipe compares the two inputs ngModelCopy and ngModel -->
      <!-- returns true if input objects are equal. In which case 'save' should be disabled -->
      <!-- This pipe is an alternate to calling compare function in .ts file anytime input changes -->
      <button
        nz-button
        nzType="link"
        class="btn-primary"
        [class.disabled]="ngModelCopy | ccCompare: ngModel"
        (click)="handleSave()"
      >
        Save
      </button>
    </div>
  </div>

  <ng-template #byBroker>
    <div class="tab-content padded-x padded-y">
      <nz-radio-group
        [(ngModel)]="ngModelCopy && ngModelCopy.customConsensusBrokerType"
        (ngModelChange)="onCcBrokerRadioButtonChange($event)"
        [nzSize]="'small'"
      >
        <label nz-radio nzValue="reaffirm">
          <ng-container *ngTemplateOutlet="reaffirmedBroker"></ng-container>
        </label>
        <label nz-radio nzValue="brokerlist">
          <ng-container *ngTemplateOutlet="brokerList"></ng-container>
        </label>
      </nz-radio-group>
      <div class="broker-list-section padded-y">
        <app-source-table
          [brokersList]="ccVars && ccVars.brokerlist"
          [showOnlyCurrent]="ccVars && ccVars.showOnlyCurrentCc"
          [sortColumn]="ccVars && ccVars.sortColumn"
          [sortDirection]="ccVars && ccVars.sortDirection"
          [useFor]="useFor"
          [ccState]="false"
          [currentActiveRadio]="ngModel.customConsensusBrokerType"
          (sortChanged)="handleSourceSortChange($event)"
          (showCurrentChanged)="handleSourceShowOnlyCurrentChange($event)"
          (selectionChanged)="handleSourceSelectionChange($event)"
          (toggleBrokerListRadio)="handleBrokerListToggle()"
        >
        </app-source-table>
      </div>
      <div *ngIf="showHideBrokerCheckbox" class="padded-y">
        <label
          class="checkbox-sm"
          nz-checkbox
          [ngModel]="ngModelCopy && ngModelCopy.hideNonCcBrokersInGrid"
          (ngModelChange)="handleCheckbox('hideNonCcBrokersInGrid', $event)"
          >Show only brokers included in my Custom Consensus in the Data
          Grid</label
        >
      </div>

      <div
        *ngIf="
          ccVars && (ccVars.nonentitledCurrent || ccVars.nonentitledNoncurrent)
        "
        [ngClass]="[
          disableAdvanceCalculation
            ? 'advanced-calculation-section-disabled'
            : 'advanced-calculation-section'
        ]"
      >
        <div
          class="advanced-calculation-section-overlay"
          *ngIf="disableAdvanceCalculation"
        ></div>
        <span class="text-sm">Advanced calculation options</span>
        <span class="divider"></span>
        <span class="text-sm text-info"
          >Custom Consensus calculation includes all brokers which haven’t
          dropped or restricted coverage. To include brokers which you aren’t
          entitled to, please use the below checkboxes.</span
        >
        <div class="padded-y">
          <label
            *ngIf="ccVars && ccVars.nonentitledCurrent"
            class="checkbox-sm"
            nz-checkbox
            [(ngModel)]="ngModelCopy && ngModelCopy.includeNonentitledCurrent"
            (ngModelChange)="
              handleCheckbox('includeNonentitledCurrent', $event)
            "
            >Include current brokers I am not entitled to in my custom consensus
            <va-icon
              class="info-icon"
              nz-tooltip
              [nzTooltipTitle]="ccVars.nonentitledCurrentBrokers.join(',')"
              [nzTooltipOverlayStyle]="{
                fontSize: '11px',
                padding: '0px',
                background: '#999'
              }"
              size="small"
              name="info-circle"
            >
            </va-icon>
          </label>
          <label
            *ngIf="ccVars && ccVars.nonentitledNoncurrent"
            class="checkbox-sm"
            nz-checkbox
            [(ngModel)]="
              ngModelCopy && ngModelCopy.includeNonentitledNoncurrent
            "
            (ngModelChange)="
              handleCheckbox('includeNonentitledNoncurrent', $event)
            "
            >Include non-current brokers I am not entitled to in my custom
            consensus
            <va-icon
              class="info-icon"
              nz-tooltip
              [nzTooltipTitle]="ccVars.nonentitledNonCurrentBrokers.join(',')"
              [nzTooltipOverlayStyle]="{
                fontSize: '11px',
                padding: '0px',
                background: '#999'
              }"
              size="small"
              name="info-circle"
            ></va-icon>
          </label>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #byDateContent>
  <ng-container>
    <div class="by-date-container">
      <span class="text-md padded-x"
        >Create a custom consensus of brokers with updates since:</span
      >
      <div nz-row class="custom-and-relative-date">
        <nz-radio-group
          [(ngModel)]="ngModelCopy && ngModelCopy.customConsensusDateType"
          (ngModelChange)="onCcRadioButtonChange($event)"
          [nzSize]="'small'"
          class="row"
        >
          <div class="custom-date-section" nz-col nzSpan="12">
            <div class="text-sm label-header">Custom date</div>
            <label nz-radio nzValue="custom">
              <ng-container *ngTemplateOutlet="customDate"></ng-container>
            </label>
            <div class="text-sm">
              <span
                [ngClass]="[
                  noOfBrokersIncluded && noOfBrokersIncluded.iserror
                    ? 'show-error'
                    : 'show-message'
                ]"
                >{{
                  customConsensusDateCopy && noOfBrokersIncluded
                    ? noOfBrokersIncluded.message
                    : ""
                }}</span
              >
            </div>
          </div>
          <div class="relative-date-section" nz-col nzSpan="12">
            <div class="text-sm label-header">Last 'n' Days</div>
            <label nz-radio nzValue="relative">
              <ng-container *ngTemplateOutlet="relativeDays"></ng-container>
            </label>
            <div class="text-sm">
              <span
                [ngClass]="[
                  noOfBrokersIncluded && noOfBrokersIncluded.iserror
                    ? 'show-error'
                    : 'show-message'
                ]"
                >{{
                  ngModelCopy && ngModelCopy.relativeDays && noOfBrokersIncluded
                    ? noOfBrokersIncluded.message
                    : ""
                }}</span
              >
            </div>
          </div>
        </nz-radio-group>
      </div>
      <span class="divider"></span>
      <div *ngIf="showHideBrokerCheckbox" class="padded-x padded-y">
        <label
          class="checkbox-sm"
          nz-checkbox
          [ngModel]="ngModelCopy && ngModelCopy.hideNonCcBrokersInGrid"
          (ngModelChange)="handleCheckbox('hideNonCcBrokersInGrid', $event)"
          >Show only brokers included in my Custom Consensus in the Data
          Grid</label
        >
      </div>
      <div class="advanced-calculation-section">
        <ng-container *ngTemplateOutlet="advanceCalcOptn"></ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #customDate>
  <ng-container>
    <span>
      <nz-date-picker
        nzMode="date"
        [nzSize]="'small'"
        [nzPlaceHolder]="'yyyy-mm-dd'"
        [nzShowToday]="false"
        [(ngModel)]="customConsensusDateCopy"
        [nzDisabledDate]="disabledDate"
        [nzDateRender]="tplRender"
        (ngModelChange)="handleCustomDateChange($event)"
        [nzRenderExtraFooter]="extraFooter"
      >
      </nz-date-picker>

      <ng-template #tplRender let-current>
        <ng-container *ngIf="current | formatDate; let datestring">
          <div
            [title]="
              eventsDataObj &&
              eventsDataObj[datestring] &&
              eventsDataObj[datestring].text
                ? eventsDataObj[datestring].text
                : (current | date: 'yyyy-MM-dd')
            "
            class="ant-calendar-date"
            [ngStyle]="
              eventsDataObj &&
              eventsDataObj[datestring] &&
              eventsDataObj[datestring].text
                ? { 'background-color': '#36abad' }
                : ''
            "
          >
            {{ current.getDate() }}
          </div>
        </ng-container>
      </ng-template>
      <!-- [class.cc-event-date-highlighter]="
            eventsDataObj[datestring] && eventsDataObj[datestring].text
          " -->
      <ng-template #extraFooter>
        <span>
          <label>Revisions available from:</label>
          <button
            nz-button
            nzType="link"
            (click)="onEffectiveStartClick()"
            style="padding: 0px 4px"
          >
            {{ ccVars.revisionsAvailableFrom }}
          </button>
        </span>
      </ng-template>
    </span>
  </ng-container>
</ng-template>

<ng-template #relativeDays>
  <ng-container>
    <span class="relative-date">
      <input
        nz-input
        placeholder="e.g. 30"
        type="number"
        [formControl]="relativeDaysControl"
        (keypress)="onKeypressEvent($event)"
      />
      <span>DAYS</span>
    </span>
  </ng-container>
</ng-template>

<ng-template #advanceCalcOptn>
  <ng-container>
    <div class="padded-x padded-y">
      <span class="text-sm">Advanced calculation options</span>
      <span class="divider"></span>
      <span class="text-sm text-info"
        >Custom Consensus calculation includes all brokers participating in
        consensus, both entitled and unentitled. To include brokers which aren’t
        participating in consensus, please use the below checkbox.</span
      >
      <div class="padded-y">
        <label
          class="checkbox-sm"
          nz-checkbox
          [(ngModel)]="ngModelCopy && ngModelCopy.includeNonCurrentBrokers"
          (ngModelChange)="onIncludeNonCurrentBrokersCheck($event)"
          >Include non-current brokers in my custom consensus
        </label>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #reaffirmedBroker>
  <ng-container>
    <span class="reaffirmed-broker">
      <span class="text-md">Exclude reaffirmed broker estimates</span>
      <va-icon
        nz-tooltip
        nzTooltipTitle="Excludes brokers who reaffirmed estimates but did not provide updated models after most recent earnings."
        nzTooltipPlacement="right"
        size="small"
        name="info-circle"
        class="reaffirmed-info-icon"
      ></va-icon>
    </span>
  </ng-container>
</ng-template>
<ng-template #brokerList>
  <div #parentElem class="padded-y">
    <span class="text-md">Create a custom consensus of brokers</span>
  </div>
</ng-template>
